export enum TimesheetDayStatusEnums {
  HOLIDAY,
  SCHEDULED_ABSENCE,
  UNAUTHORIZED_ABSENCE,
  WORK_DAY,
  DAY_OFF,
}
